<script setup>

import { inject, computed, watch } from 'vue';
import Chart from 'primevue/chart';
import EditeurGraphique from './EditeurGraphique.vue';

const { graphique, modeEdition } = defineProps({
	graphique: Object,
	modeEdition: Boolean
});

const selectionnerElement = inject('selectionnerElement');

const optionsGraphique = computed(() => {
	return {
		responsive: false,
		maintainAspectRatio: false,
		scales: echelles.value,
		plugins: {
			legend: {
				position: 'right'
			}
		}
	};
});

const echelles = computed(() => {
	switch(graphique.typeGraphique) {
		case 'COURBE':
		case 'HISTOGRAMME':
			var libelleAxe = graphique.axePrincipal.valeur?.valFormat;
			return {
				x: {
					title: {
						display: libelleAxe,
						text: libelleAxe,
						align: 'end',
						font: {
							style: 'italic'
						}
					}
				}
			};
		case 'CIRCULAIRE':
		case 'DOUGHNUT':
		case 'RADAR':
			return null;
	}
});

const donneesGraphique = computed(() => {
	return {
		labels: graphique.axePrincipal.valeurs.map(val => val.valeur?.valFormat),
		datasets: graphique.series.map(serie => {
			return {
				label: serie.valeur?.valBrute ? serie.valeur.valBrute : '',
				borderColor: getCouleurTrait(serie),
				borderWidth: getEpaisseurTrait(),
				backgroundColor: getCouleurRemplissage(serie),
				data: serie.valeurs.map(val => val.valeur?.valNative)
			};
		})
	}
});

watch(() => graphique.selectionPremierElement, (sel) => {
	if (sel) {
		delete graphique.selectionPremierElement;
		selectionnerElement(graphique.axePrincipal, graphique);
	}
});

function traduireTypeGraphiqueEnChartType(typeGraphique) {
	switch(typeGraphique) {
		case 'COURBE':
			return 'line';
		case 'HISTOGRAMME':
			return 'bar';
		case 'CIRCULAIRE':
			return 'pie';
		case 'DOUGHNUT':
			return 'doughnut';
		case 'RADAR':
			return 'radar';
	}
}

function getEpaisseurTrait() {
	switch(graphique.typeGraphique) {
		case 'HISTOGRAMME':
			return 0;
		case 'COURBE':
		case 'CIRCULAIRE':
		case 'DOUGHNUT':
		case 'RADAR':
			return 1;
	}
}

function getCouleurTrait(serie) {
	switch(graphique.typeGraphique) {
		case 'HISTOGRAMME':
			return 'transparent';
		case 'COURBE':
			return serie.couleurs;
		case 'CIRCULAIRE':
		case 'DOUGHNUT':
		case 'RADAR':
			return 'var(--couleur-bordure)';
	}
}

function getCouleurRemplissage(serie) {
	switch(graphique.typeGraphique) {
		case 'HISTOGRAMME':
		case 'COURBE':
		case 'CIRCULAIRE':
		case 'DOUGHNUT':
		case 'RADAR':
			return serie.couleurs;
	}
}

</script>

<template>
	<div class="graphique"
	  :style="graphique.style">
		<EditeurGraphique v-if="modeEdition" 
			:graphique="graphique"
			@desactivationModeEdition="$emit('desactivationModeEdition')" />
		<template v-else>
			<Chart
				:type="traduireTypeGraphiqueEnChartType(graphique.typeGraphique)"
				:data="donneesGraphique" 
				:options="optionsGraphique" 
				:height="250"
				:width="700"
				@dblclick="$emit('activationModeEdition')" />
		</template>
	</div>
</template>

<style scoped>

.graphique {
	border-style: solid;
	border-width: 0px;
}

</style>